import { useQuery } from 'react-query';

import { axios } from '@/library/axios';
import type { QueryConfig } from '@/library/react-query';

export type VerifyType = {
  id: string | undefined;
  blockId: string;
  goldInRupees: number;
  weightInGrams: number;
};

export const getVerifyPrice = async (data: VerifyType) => {
  const { id, blockId, goldInRupees, weightInGrams } = data;
  return axios.get(
    `dg/customers/${id}/sell-orders?blockId=${blockId}&goldAmountInRupee=${goldInRupees}&weightInGram=${weightInGrams}`
  );
};

type QueryFnType = typeof getVerifyPrice;
export type UseGetVerifyPrice = {
  config?: QueryConfig<QueryFnType>;
  data: VerifyType;
};

export const useVerifyPrice = ({ data }: UseGetVerifyPrice) => {
  // { config = {},
  return useQuery({
    queryKey: ['verifyPrice'],
    queryFn: () => getVerifyPrice(data),
    enabled: !!data.id,
  });
};
